module.exports = __webpack_public_path__ + "img/19.38d72773.png";